import React from 'react'

const tooltipRefs = {
    tooltipRef: React.createRef(),
}

let tooltipAnchorSequence = 0

export function getTooltipRef() {
    return tooltipRefs.tooltipRef
}

function getTooltipAnchorSelector(anchor) {
    let anchorId = anchor.getAttribute('data-treechat-tooltip-anchor')

    if (!anchorId) {
        tooltipAnchorSequence += 1
        anchorId = `treechat-tooltip-anchor-${tooltipAnchorSequence}`
        anchor.setAttribute('data-treechat-tooltip-anchor', anchorId)
    }

    return `[data-treechat-tooltip-anchor="${anchorId}"]`
}

export function openTooltip(anchor, { content = undefined, place = undefined, delay = 0 } = {}) {
    const tooltip = getTooltipRef().current
    if (!anchor || !tooltip?.open) return

    const options = {
        anchorSelect: getTooltipAnchorSelector(anchor),
        delay,
    }
    if (content != null) options.content = content
    if (place) options.place = place

    tooltip.open(options)
}

export function closeTooltip(anchor, { delay = 0 } = {}) {
    const tooltip = getTooltipRef().current
    if (!tooltip?.close) return
    if (anchor && tooltip.activeAnchor && tooltip.activeAnchor !== anchor) return

    tooltip.close({ delay })
}

export function showTooltipConfirmation(
    anchor,
    {
        content = 'Copied!',
        restoreContent = undefined,
        duration = 2000,
        closeAfter = false,
        place = 'bottom',
    } = {},
) {
    if (!anchor || window.isPanelScrolling) return

    anchor.setAttribute('data-tooltip-content', content)
    closeTooltip()

    window.setTimeout(() => {
        if (!anchor.isConnected) return

        openTooltip(anchor, { content, place })

        window.setTimeout(() => {
            if (!anchor.isConnected) return

            if (restoreContent != null) {
                anchor.setAttribute('data-tooltip-content', restoreContent)
            }

            if (closeAfter) {
                closeTooltip(anchor)
            } else if (restoreContent != null && getTooltipRef().current?.activeAnchor === anchor) {
                openTooltip(anchor, { content: restoreContent, place })
            }
        }, duration)
    }, 10)
}
